const APP_STAGE = process.env.APP_STAGE || process.env.NEXT_PUBLIC_APP_STAGE;
const IS_DEVELOPMENT = APP_STAGE === 'development';
const IS_PRODUCTION = process.env.NODE_ENV === 'production';

/**
 * Set app default locale
 */
const DEFAULT_LOCALE = 'cs';

/**
 * App supported locale list
 */
const SUPPORTED_LOCALES = [DEFAULT_LOCALE, 'en', 'de', 'sk'];

/**
 * Actually translated locale list
 */
const TRANSLATED_LOCALES = [DEFAULT_LOCALE, 'en', 'de', 'sk'];

/**
 * Returns the locale if supported, otherwise returns the default locale
 * @param locale
 * @returns {string|*}
 */
const getLocale = (locale) => {
	if (TRANSLATED_LOCALES.includes(locale)) return locale;
	return DEFAULT_LOCALE;
};

const I18N_PROJECT_NAME = 'nfctron-tickets';
const getNamespaceLocaleJsonPath = (ns, lng) => {
	return `${I18N_PROJECT_NAME}-${ns}/${getLocale(lng)}.json`;
};

/**
 * Supported namespaces
 * @type {string[]}
 */
const NAMESPACES = ['main', 'common'];

/**
 * Configuration for next-translate
 * @see https://github.com/aralroca/next-translate/tree/master#3-configuration
 * @type {import("next-translate").I18nConfig}
 */
const nextTranslateI18n = {
	locales: TRANSLATED_LOCALES,
	defaultLocale: DEFAULT_LOCALE,
	localeDetection: false,
	loadLocaleFrom: (lang, ns) => import(`./locales/${getNamespaceLocaleJsonPath(ns, lang)}`).then((m) => m.default),
	defaultNS: 'main',
	nsSeparator: '::',
	keySeparator: false,
	loggerEnvironment: IS_DEVELOPMENT ? 'client' : undefined,
	interpolation: {
		/** TODO: define various formatting options */
		/** @see https://github.com/aralroca/next-translate/tree/master#9-formatter */
		format: (value, format, lng) => {
			if (format === 'uppercase') return value.toUpperCase();
			return value;
		},
	},
	/** de-activate webpack loader due to turborepo usage */
	/** @see https://github.com/aralroca/next-translate/blob/master/examples/without-loader/pages/more-examples/index.js */
	loader: false,
	pages: {
		/** TODO: atomize page namespaces */
		'*': NAMESPACES,
	},
};

module.exports = {
	/** configuration for next-translate */
	...nextTranslateI18n,
	/** other i18n configuration */
	DEFAULT_LOCALE,
	SUPPORTED_LOCALES,
	TRANSLATED_LOCALES,
	I18N_PROJECT_NAME,
	NAMESPACES,
	getLocale,
	getNamespaceLocaleJsonPath,
};
